import { Box } from "@chakra-ui/react";
import { ColorIcon, VStack, call, colors, useResponsive } from "goi_common";
import { useEffect } from "react";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageOgTitle: "전화 한 번으로 장례 비용 몇백만원을 아껴드려요- [우리가 찾던 장례전문가, 고이]",
      pageDescription:
        "이용하지 않으셔도 좋습니다. 고이장례연구소, 장례에 관한 모든 것을 쉽게 알려드려요.",
      pageKeywords:
        "후불제, 후불제상조, 선불제, 선불제상조, 후불제상조 선불제상조, 장례, 장례상담, 상조, 상조순위, 상조 기준, 상조차이, 상조비교, 상조회사, 상조회사서비스, 보람상조, 프리드라이프, 예다함",
      pageOgDescription:
        "이용하지 않으셔도 좋습니다. 고이장례연구소, 장례에 관한 모든 것을 쉽게 알려드려요.",
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/platform/prepare/prepare-1-2.png`,
    },
  };
};
export default function DirectCall() {
  const { isBiggerThanLg } = useResponsive();

  useEffect(() => {
    call("1666-9784", false);
  }, []);
  return (
    <VStack width="100%" alignItems="center" height="100vh">
      <VStack maxWidth="720px" width="100%" height="100%" alignItems="center" padding="0px 0px">
        <VStack
          justifyContent="center"
          alignItems="center"
          padding="60px 0px"
          width="100%"
          height="100%"
          background={colors.gray50}
        >
          <VStack
            alignItems="center"
            gap={10}
            onClick={() => {
              call("1666-9784", false);
            }}
          >
            <Box
              style={{
                display: "flex",
                borderRadius: 100,
                width: 100,
                height: 100,
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.16)",
                justifyContent: "center",
                alignItems: "center",
                background: "white",
              }}
            >
              <ColorIcon name="icon-call-mono" color={colors.gray900} size={60} />
            </Box>
            <Box className={isBiggerThanLg ? "subtitle_21_b gray700" : "subtitle_18_b gray700"}>
              상담하기
            </Box>
          </VStack>
          <Box
            className={isBiggerThanLg ? "subtitle_21_b gray700" : "subtitle_18_b gray700"}
            padding="10px 0px 0px"
          >
            1666-9784
          </Box>
        </VStack>
      </VStack>
    </VStack>
  );
}
